import type { Broker, Rights } from '@/features/Broker/types';
import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';

export class BrokerHttpService extends HttpService {
  loadBroker(): HttpClientResponse<Broker> {
    return this.httpClient.get('makler/me');
  }

  loadRights(): HttpClientResponse<Rights> {
    return this.httpClient.get('makler/me/rechte');
  }

  heartbeat(id: string): HttpClientResponse<void> {
    return this.httpClient.get('heartbeat', {
      params: {
        berechnungsId: id,
      },
    });
  }

  loadSettings(brokerId: number): HttpClientResponse<Record<string, unknown>> {
    return this.httpClient.get(`settings/${brokerId}`);
  }

  saveBrokerSettings(
    brokerId: number,
    settings: unknown,
  ): HttpClientResponse<void> {
    return this.httpClient.post(`settings/${brokerId}`, {
      data: {
        settings,
      },
    });
  }

  transmitSoftfairBrokerData(): HttpClientResponse<string> {
    return this.httpClient.put('makler/');
  }

  transmitSoftfairBrokerId(
    brokerId: string,
    insuranceId: string,
    calculationId: string,
    pool?: string,
  ): HttpClientResponse<null> {
    return this.httpClient.put(
      `makler/vermittlernummern/anbieter/insuranceCompanies/${insuranceId}`,
      {
        data: {
          isPooling: pool !== undefined,
          pool,
          brokerId,
        },
        params: {
          berechnungsId: calculationId,
        },
      },
    );
  }
}
